import * as React from 'react';

export const Footer: React.SFC = () => (
  <footer className="footer">
    <div className="wrapper wrapper--modified">
      <p className="t-micro u-opacity--40">
        Copyright &copy; 2018 Auric Oak. All Rights Reserved.
      </p>
    </div>
  </footer>
);



// WEBPACK FOOTER //
// ./src/main/components/Footer.tsx